import axios from 'axios'
import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import ButtonOutline from 'src/components/atoms/ButtonOutline'
import CardArticle from 'src/components/molecules/CardArticle'
import CardLoader from 'src/components/orgainsms/CardProduct/CardLoader'
import SecondHeader from 'src/components/orgainsms/SecondHeader'
import useSwr from 'swr'

const fether = async url => {
  const response = await axios(url)
  return response.data
}

const ArticleFilter = () => {
  const API = process.env.REACT_APP_API
  const location = useLocation()
  const navigate = useNavigate()
  const k = location.pathname.split('/').pop()
  const [keyword, setKeyword] = useState(k)
  const { data, isLoading } = useSwr(
    API + '/article-category/' + keyword,
    fether
  )

  const handleSearch = () => {
    navigate({
      pathname: '/articles/search/' + keyword
    })
  }
  useEffect(() => {
    setKeyword(k)
  }, [location])

  return (
    <div>
      <SecondHeader
        onSearch={handleSearch}
        onChange={e => setKeyword(e.target.value)}
      />
      <div className='px-4 lg:px-14 pt-6 pb-32'>
        <div className='mt-[50px]'>
          <div className='py-8'>
            <div className='flex justify-between items-end'>
              <h2 className='text-[#2FAB73] text-[24px]' id='trivia'>
                {data?.title}
              </h2>
              <ButtonOutline title={'see more...'} />
            </div>
          </div>
          <div className='grid grid-cols-2 lg:grid-cols-3 gap-[30px]'>
            {isLoading && (
              <>
                {[1, 2, 3, 4, 5, 6].map(item => (
                  <CardLoader type={'horizontal'} key={item} />
                ))}
              </>
            )}
            {data?.articles?.map(art => (
              <CardArticle
                type='horizontal'
                key={art.id}
                title={art.title}
                slug={`/articles/${art.slug}`}
                publishedAt={art.published_at}
                image={process.env.REACT_APP_IMAGE + '/article/' + art.image}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default ArticleFilter
